import { createAction } from '@reduxjs/toolkit';
export var updatePoolShares = createAction('user/updatePoolShares');
export var updateWalletType = createAction('user/updateWalletType');
export var updatePendingChainId = createAction('user/updatePendingChainId');
export var updateSelectedConnectionType = createAction('user/updateSelectedConnectionType');